import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

import {
  BACKEND_KEYS,
  BACKEND_METHOD_CONSTANT,
  BACKEND_METHOD_TYPES,
  URL_CONSTANT,
} from "./url-constant";

import { BaseAPI } from "./baseAPI";
import { CheckpointServerModel } from "../models/checkpoint-server.model";
import { AuthService } from "./auth.service";
import { map } from "rxjs/operators";
import * as underscore from "underscore";

@Injectable()
export class CheckpointServersService extends BaseAPI {
  constructor(public http: HttpClient, public authService: AuthService) {
    super(http, authService);
  }
  username = this.authService.user.username;
  password = this.authService.user.password;

  getServerFromId(serverId: number): Observable<CheckpointServerModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.username)
      .set(BACKEND_KEYS.pass, this.password);

    const url =
      BACKEND_METHOD_CONSTANT.checkPointServer + '/' +
      serverId;

    return this.get(url, httpParams)
      .pipe(
        map((server: CheckpointServerModel) => {
          return server ? server : undefined;
        })
      )
      .catch(this.handleError);
  }

  getServers(): Observable<CheckpointServerModel[]> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.username)
      .set(BACKEND_KEYS.pass, this.password);

    const url =
      BACKEND_METHOD_CONSTANT.checkPointServer + BACKEND_METHOD_TYPES._list;

    return this.get(url, httpParams)
      .pipe(
        map((servers: CheckpointServerModel[]) => {
          const array = underscore.map(servers, function (server) {
            return new CheckpointServerModel(
              server.id,
              server.name,
              server.domain,
              server.userName,
              server.password,
              server.proxy,
              server.sites
            );
          });
          // console.log(regionsArray)
          return array ? array : undefined;
        })
      )
      .catch(this.handleError);
  }
  updateServer(
    server: CheckpointServerModel
  ): Observable<CheckpointServerModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.username)
      .set(BACKEND_KEYS.pass, this.password);
    const url = BACKEND_METHOD_CONSTANT.checkPointServer;

    return this.put(url, httpParams, server)
      .pipe(
        map((server: CheckpointServerModel) => {
          return server ? server : undefined;
        })
      )
      .catch(this.handleError);
  }
  createServer(
    server: CheckpointServerModel
  ): Observable<CheckpointServerModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.username)
      .set(BACKEND_KEYS.pass, this.password);
    const url = BACKEND_METHOD_CONSTANT.checkPointServer;

    return this.post(url, httpParams, server)
      .pipe(
        map((server: CheckpointServerModel) => {
          return server ? server : undefined;
        })
      )
      .catch(this.handleError);
  }
  disassociateSiteFromId(siteId: number): Observable<CheckpointServerModel> {
    const httpParams = new HttpParams()
      .set(BACKEND_KEYS.user, this.username)
      .set(BACKEND_KEYS.pass, this.password);

    const url =
      BACKEND_METHOD_CONSTANT.checkPointServer +
      BACKEND_METHOD_TYPES.site + '/' +
      siteId;

    return this.delete(url, httpParams)
      .pipe(
        map((server: CheckpointServerModel) => {
          return server ? server : undefined;
        })
      )
      .catch(this.handleError);
  }
}
